import React, {useState, useEffect} from "react"
import {Box} from "@material-ui/core"
import StopRoundedIcon from '@material-ui/icons/StopRounded';
import Skeleton from '@material-ui/lab/Skeleton';
import {headers} from "constants/csrf"
import axios from 'axios'
import { useTranslation } from 'react-i18next';

export default function EventColors() {
  const {t} = useTranslation();
  const [colors, setColors] = useState([])
  const [load, setLoad] = useState(false)
  const isMountedRef = React.useRef(true); // Track if component is mounted

  const styles = {
    description: {
      fontSize: '14px',
      fontWeigt: '300',
      textAlign: 'left'
    }
  };

  async function getEventColors() {
    try {
      const {data} = await axios.get('api/v1/calendar_events/colors', {headers: headers});

      // Only update state if component is still mounted
      if (isMountedRef.current) {
        setColors(data);
        setLoad(true);
      }
    } catch (error) {
      console.error('Error fetching event colors:', error);
    }
  }

  useEffect(() => {
    async function fetchData() {
      await getEventColors();
    }
    fetchData();

    // Cleanup function to prevent memory leaks
    return () => {
      isMountedRef.current = false;
    };
  }, [])

  return (
    <React.Fragment>
    { (!load) &&
    <Skeleton height={21} />
    ||
      Object.keys(colors).map((key, index) =>
        <Box key={index} mr={3} component="span">
          <StopRoundedIcon fontSize="large" style={{color: colors[key], fontSize: '28px'}} />
          <span styles={styles.description}>
            {t(`calendar.${key}`)}
          </span>
        </Box>
      )
    }
    </React.Fragment>
  )
}
